import {Engine, RouteHandler} from 'routerjs/dist/engines/Engine';
type ArrayHistoryEngineCreator = () => () => Engine;

export const ArrayHistoryEngine: ArrayHistoryEngineCreator = () => () => {
  let engine: Engine;
  let pathname: string = '';
  const history: string[] = [];
  const handlers: RouteHandler[] = [];
  const exitHandlers: RouteHandler[] = [];
  let previousPath: string | null = null;

  const executeHandlers = async (path: string) => {
    await handlers.reduce((acc, h) => {
      return acc.then(() => h(path));
    }, Promise.resolve());
  };

  const executeExitHandlers = async (path: string) => {
    if(path !== null){
      await exitHandlers.reduce((acc, h) => {
        return acc.then(() => h(path));
      }, Promise.resolve());
    }
  };

  const historyPush = (path) => {
    previousPath = pathname;
    pathname = path;
    history.push(path);
  }

  engine = {
    setup: () => {},
    teardown: () => {},
    back: () => {
      if(history.length > 1){
        history.pop();
        engine.navigate(history[history.length-1])
      } else {
        engine.navigate('/');
      }
    },
    forward: () => {},
    go: () => {},

    addRouteChangeHandler: (handler) => {
      handlers.push(handler);
    },

    addRouteExitHandler: (handler) => {
      exitHandlers.push(handler);
    },

    navigate: async (path) => {
      if (pathname !== path) {
        await executeExitHandlers(previousPath);
        historyPush(path);
        await executeHandlers(path);
      }
    },

    setLocation: (path) => {
      if (pathname !== path) {
        historyPush(path);
      }
    },

    run: (path?: string) => {
      const url = path || pathname;
      if (pathname !== url) {
        historyPush(url);
      }
      executeHandlers(url);
    },
  };

  return engine;
}
